import React, { useState } from "react";
import { motion } from "framer-motion";
import { animations } from "../../animations/animations";

const Form = ({
  inputs,
  actionBtnText,
  formErrors,
  selectedNavIndex,
  submitHandler,
}) => {
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const handleAnimationComplete = () => {
    setIsInitialLoad(false);
  };

  return (
    <motion.div
      className="commande-form"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.9 }}
      onAnimationComplete={handleAnimationComplete}
    >
      <p>Bienvenue! Remplissez le Formulaire ci-dessus et Placez Votre Commande</p>
      
      <form>
        {inputs.map((input, index) => (
          <motion.div
            key={index}
            className="input-container"
            initial={{ position: "relative", right: "-100px", opacity: 0 }}
            animate={{ position: "relative", right: "0", opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <label htmlFor={input.name ? input.name : `input-${index}`}>
              {input.label}
            </label>
            {input.type === "select" || Array.isArray(input.options) ? (
              <select
                id={input.name ? input.name : `input-${index}`}
                name={input.name ? input.name : undefined}
                className={input.className ? input.className : "input"}
                value={
                  Object.prototype.hasOwnProperty.call(input, "value")
                    ? input.value
                    : null
                }
                onChange={input.onChange ? input.onChange : null}
                disabled={Boolean(input.disabled)}
                required={input.required !== false && !input.disabled}
              >
                <option value="" className="black" disabled>
                  {input.placeholder ? input.placeholder : "Select an option"}
                </option>
                {(input.options ? input.options : []).map((option, optionIndex) => {
                  const optionValue = input.optionValues
                    ? input.optionValues[optionIndex]
                    : option;
                  return (
                    <option
                      key={
                        optionValue !== undefined && optionValue !== null
                          ? optionValue
                          : optionIndex
                      }
                      value={
                        optionValue !== undefined && optionValue !== null
                          ? optionValue
                          : option
                      }
                      className="black"
                    >
                      {option}
                    </option>
                  );
                })}
              </select>
            ) : (
              <input
                id={input.name ? input.name : `input-${index}`}
                type={input.type}
                placeholder={input.placeholder}
                value={
                  Object.prototype.hasOwnProperty.call(input, "value")
                    ? input.value
                    : null
                }
                onChange={input.onChange ? input.onChange : null}
                disabled={Boolean(input.disabled)}
                readOnly={Boolean(input.readOnly)}
                required={input.required !== false && !input.disabled}
                min={input.min}
                max={input.max}
                step={input.step}
              />
            )}
          </motion.div>
        ))}

        <motion.div
          className="flex align-items-end"
          initial={{ right: "-100px", opacity: 0 }}
          animate={animations.quantityContainer}
          transition={{ delay: 0.9 }}
        >
          {formErrors ? (
            <p className="small-text grey">Veuillez Remplir Tous Les Champs</p>
          ) : null}

          <div className="submit-container" onClick={(e) => submitHandler(e)}>
            <button type="submit">{actionBtnText}</button>
          </div>
        </motion.div>
      </form>
    </motion.div>
  );
};

export default Form;
